import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products API
export const productsApi = {
  getAll: (category) => {
    const params = category && category !== 'all' ? `?category=${category}` : '';
    return axios.get(`${API}/products${params}`);
  },
  getById: (id) => axios.get(`${API}/products/${id}`),
  getCategories: () => axios.get(`${API}/products/categories`),
};

// Cart API
export const cartApi = {
  get: (sessionId) => axios.get(`${API}/cart/${sessionId}`),
  add: (sessionId, productId, quantity = 1) =>
    axios.post(`${API}/cart/add`, { session_id: sessionId, product_id: productId, quantity }),
  update: (sessionId, productId, quantity) =>
    axios.put(`${API}/cart/update`, { session_id: sessionId, product_id: productId, quantity }),
  remove: (sessionId, productId) =>
    axios.delete(`${API}/cart/remove`, { data: { session_id: sessionId, product_id: productId } }),
  clear: (sessionId) => axios.delete(`${API}/cart/${sessionId}/clear`),
};

// Orders API
export const ordersApi = {
  create: (sessionId, shippingAddress, originUrl) =>
    axios.post(`${API}/orders/create`, {
      session_id: sessionId,
      shipping_address: shippingAddress,
      origin_url: originUrl,
    }),
  getPaymentStatus: (sessionId) => axios.get(`${API}/orders/payment-status/${sessionId}`),
  verifyRazorpay: (paymentId, orderId, signature) =>
    axios.post(`${API}/orders/razorpay-verify`, null, {
      params: {
        razorpay_payment_id: paymentId,
        razorpay_order_id: orderId,
        razorpay_signature: signature,
      },
    }),
  get: (orderId) => axios.get(`${API}/orders/${orderId}`),
  getShippingRates: () => axios.get(`${API}/orders/shipping/rates`),
};

// Contact API
export const contactApi = {
  submit: (data) => axios.post(`${API}/contact`, data),
};

// Newsletter API
export const newsletterApi = {
  subscribe: (email) => axios.post(`${API}/newsletter/subscribe`, { email }),
  unsubscribe: (email) => axios.post(`${API}/newsletter/unsubscribe`, { email }),
};

export default {
  products: productsApi,
  cart: cartApi,
  orders: ordersApi,
  contact: contactApi,
  newsletter: newsletterApi,
};
